import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '../../../../../themes/stena-recycling/spacing';
import { colors } from '../../../../../themes/stena-recycling/colors';
import { typography } from '../../../../../themes/stena-recycling/typography';

export const StyledTableHeader = styled.thead<{ sticky?: boolean }>`
  padding: 0 ${spacing.xsmall};
  min-height: 57px;

  ${({ sticky }) =>
    sticky &&
    css`
      th {
      position: sticky;
      top: 0;
      z-index: 0;
      background-color: ${colors.base.white};
       box-shadow: inset 0 -1px 0 ${colors.monochrome.grey50};  /* looks like a bottom border */
       border-bottom: 0;
    `}
`;

export const TableHeaderRow = styled.tr`
  min-height: 57px;
`;

export const TableHeaderCell = styled.th<{ slim?: boolean }>`
  padding: ${({ slim }) => (slim ? '0px' : spacing.xsmall)} ${spacing.xsmall};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid ${colors.monochrome.grey50};
  text-align: left;
  ${typography.body.mediumBold};
  color: ${colors.primary.grey};
  vertical-align: middle;
`;

export const TableHeaderCellInner = styled.div<{ align?: 'left' | 'right' }>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ align = 'left' }) => (align === 'right' ? 'flex-end' : 'flex-start')};
`;

export const HeaderNameWrapper = styled.div<{ align?: 'left' | 'right' }>`
  display: flex;
  text-align: ${({ align = 'left' }) => align};
  align-items: center;
  gap: ${spacing.xxsmall};
`;
